import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Iconify from "../iconify/Iconify";

export default function InboxTable(props) {
	return (
		<TableContainer component={Paper}>
			<Table sx={{ minWidth: 650 }} aria-label="simple table">
				<TableHead>
					<TableRow>
						<TableCell>ID</TableCell>
						<TableCell>User ID</TableCell>
						<TableCell>Subject</TableCell>
						<TableCell>Viewed</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{props?.rows?.map((row, index) => (
						<TableRow
							key={index}
							sx={{
								"&:last-child td, &:last-child th": { border: 0 },
							}}
						>
							<TableCell component="th" scope="row">
								{row.adminInboxMessageId}
							</TableCell>
							<TableCell component="th" scope="row">
								{row.userId}
							</TableCell>
							<TableCell component="th" scope="row">
								{row.subject}
							</TableCell>

							<TableCell component="th" scope="row">
								{row.status ? (
									<Iconify icon={"eva:checkmark-circle-2-outline"} sx={{ color: "green" }} />
								) : (
									<Iconify icon={"eva:close-circle-outline"} sx={{ color: "red" }} />
								)}
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
